<template>
  <div class="min-h-screen flex items-center justify-center text-ink-soft">
    <font-awesome-icon icon="circle-notch" spin class="mr-2" /> Signing out…
  </div>
</template>

<script>
export default {
  async mounted() {
    await this.$store.dispatch('auth/logout')
    this.$router.replace({ name: 'Login' })
  },
}
</script>
